import React from 'react';
import {Popup} from 'semantic-ui-react';
import * as Panel2 from './panel';
import * as CGReact from './cg/cgreact';

const inputType = 'string' as const;
type PanelStringProps = Panel2.PanelProps<typeof inputType>;

const MAX_DISPLAY_LENGTH = 100;

const PanelString: React.FC<PanelStringProps> = props => {
  const nodeValueQuery = CGReact.useNodeValue(props.input.path);
  if (nodeValueQuery.loading) {
    return <div>-</div>;
  }
  // Handle null case, because we infer incorrect types in mediaTable.ts
  // currently :(
  const fullStr = nodeValueQuery.result ?? '-';
  if (fullStr.length > MAX_DISPLAY_LENGTH) {
    return (
      <Popup
        trigger={<div>{fullStr.slice(0, MAX_DISPLAY_LENGTH) + '...'}</div>}
        content={
          <div
            style={{
              maxHeight: 400,
              maxWidth: 1200,
              overflow: 'auto',
              fontSize: 14,
            }}>
            {fullStr}
          </div>
        }
      />
    );
  }
  return <div>{fullStr}</div>;
};

export const Spec: Panel2.PanelSpec = {
  id: 'string',
  Component: PanelString,
  inputType,
};
